import { gql } from "__generated__/gql";

export const deleteCargo_mutation = gql(`#graphql
	mutation deleteCargo_cargoBlock($id: Long!, $deleteEmptyVoyage: Boolean = true) {
		deleteCargo(id: $id, deleteEmptyVoyage: $deleteEmptyVoyage)
	}
`);

export const cargos_query = gql(`#graphql
	query cargos_cargos($search: CargoSearch!, $pagination: Pagination) {
		cargos(search: $search, pagination: $pagination) {
			totalElements
			content {
				id
				cargoNumber
				hasDangerousGoods
				...CargoServices
				charter {
					...ShipLinkDialogSalesCharter
					...SalesCharterStatusChangeSalesCharter

					id
					type
					subtype
					charterNumber
					debtor {
						id
						name
					}

					firstLoadingDate
					broker {
						id
						name
					}
					internalNotes
					cargos {
						id
						actions {
							type
						}
						firstLoadingAction {
							start
							end
							type
							shipToShip
							location {
								id
								description
								locationGroups {
									description
									type
								}
							}
						}
						lastDischargingAction {
							start
							end
							type
							shipToShip
							location {
								id
								description
								locationGroups {
									description
									type
								}
							}
						}
					}
				}
				lastStatusChange {
					...statusChangeFragment
				}
				statusChanges {
					...statusChangeFragment
				}
				product {
					id
					code
					name
					adnAttributes {
						unNumber
					}
					description
				}
				dimensions {
					length
					width
					height
				}
				firstLoadingAction {
					...CargoActionWithVoyage
				}
				lastDischargingAction {
					...CargoActionWithVoyage
				}
				teu
				weight
				volume
				isWeightPrimary
				isVolumePrimary
				waterLevelOptimised
				searchLabel
				billOfLadingNumber
				bookingReference
				loadingReference
				dischargingReference
				productDetails
				revenue
				color
				created
				actions {
					id
					start
					end
					type
					call {
						id
						createTwinCall
						location {
							id
							description
							locationGroups {
								id
								description
								type
							}
						}
						comments {
							...comment
						}
						voyage {
							id
							voyageNumber
						}
					}
				}
				deliveryCondition {
					id
					description
				}
				comments {
					...comment
				}
			}
		}
	}
`);

export const charters_query = gql(`#graphql
	query getCargoChartersCharters($search: CharterSearch!, $pagination: Pagination!) {
		charters(search: $search, pagination: $pagination) {
			totalElements
			content {
				id
				charterNumber
				type
				creditor {
					id
					name
				}
				debtor {
					id
					name
				}
				... on SalesCharter {
					customerReference
					cargos {
						id
					}
				}
				createdOn
			}
		}
	}
`);

export const charter_query = gql(`#graphql
	query charter_cargoCharter($id: Long!) {
		charter(id: $id) {
			id
			charterNumber
			creditor {
				id
				name
			}
			debtor {
				id
				name
			}
		}
	}
`);

export const cargoForm_query = gql(`#graphql
query cargoForm($id: Long!) {
	cargo(id: $id) {
		id
		cargoNumber
		nominationNumber
		charter {
			id
			type
			contract {
				validFrom
				validUntil
			}
		}
		voyage {
			id
			voyageNumber
			ship {
				id
				name
			}
		}
		product {
			id
			description
		}
		containerOperator {
			id
			name
		}
		supplier {
			id
			name
		}
		consignor {
			id
			name
		}
		consignee {
			id
			name
		}
		reference
		loadingReference
		dischargingReference
		connectingVisitLoadingCallReferenceNumber
		connectingVisitDischargingCallReferenceNumber
		containerNumber
		masterBundleContainerNumber
		containerType {
			isoTypeCode
			displayCode
		}
		weight
		grossWeight
		tareWeight
		verifiedGrossWeight
		totalLoadingWeight
		declaredFinalWeight
		volume
		empty
		desiredTemperature
		temperatureRangeLower
		temperatureRangeUpper
		sealed
		sealNumber
		waNumber
		bookingReference
		loaded
		discharged
		transportType
		product {
			id
			code
			name
			description
			densityKgM3
		}
		productDetails
		unNumbers {
			unNumber
		}
		reeferCheckType
		imoClass
		billOfLadingNumber
		humidity
		remarks
		scacCode
		scacCodeDischarging
		damage
		releasedForBarge
		releasedForTrain
		releasedForTruck
		deliveryCondition {
			id
			key
			description
		}
		overheight
		overlength
		overlengthBehind
		overwidthRight
		overwidthLeft
		doorOpen
		chains
		generator
		deepseaShipNameLoading
		deepseaShipImoLoading
		deepseaVoyageNumberLoading
		deepseaEtaLoading
		deepseaShipNameDischarging
		deepseaShipImoDischarging
		deepseaVoyageNumberDischarging
		deepseaEtaDischarging
		deepseaEstimateDischarge
		isNitrogenBlanketingRequired
		isNitrogenPurgingRequired
		isInhibitedProduct
		isHoseRentalRequired
		isTemperatureControlRequired
		isCleaningRequired
		waterLevelOptimised
		weightOptionPercentage
		weightToleranceType
		weightOptionType
		declaredFinalWeight
		previousInlandTerminal {
			id
			description
		}
		nextInlandTerminal{
			id
			description
		}
		previousPort
		nextPort
		finalPort
		revenue
		actions {
			id
			type
			location {
				id
				description
				type
				locationGroups {
					id
					description
					type
				}
			}
			call {
				id
			}
			surveyor {
				id
				name
			}
			notes
			terminalPlanningNotes
			connectingVisitNotes
			reference
			weight
			volume
			start
			end
			displayAsWindow
			simulatedTimestamp
			shipToShip
			connectingShipPortVisit {
				id
				location {
					id
					description
					locationGroups {
						id
						description
						type
					}
				}
				agent {
					id
					name
				}
				ship {
					id
					name
				}
				from
				until
			}
			connectingShipBerthing {
				id
				connectingShipPortVisit {
					id
				}
				window {
					from
					to
				}
				location {
					id
					description
					locationGroups {
						id
						description
						type
					}
				}
				createdOn
			}
			limitType
			limitValue
			includedForLaytimeCalculation
		}
		nominatedWeight
		nominatedVolume
		isWeightPrimary
		isVolumePrimary
	}
}
`);

export const getReeferChecklistById_query = gql(`#graphql
	query reeferCheckListById($id: Long!) {
		cargo(id: $id) {
			id
			loadingReference
			containerNumber
			containerType {
				isoTypeCode
				displayCode
			}
			voyage {
				id
				voyageNumber
				ship {
					name
				}
			}
			desiredTemperature
			firstLoadingAction {
				id
				call {
					id
					pta
					ata
					location {
						id
						description
					}
				}
			}
			lastDischargingAction {
				id
				call {
					id
					pta
					ata
					location {
						id
						description
					}
				}
			}
			reeferCheckType
			reeferChecklist {
				location
				setPoint
				plugin {
					id
					timestamp
					temperature
				}
				plugout {
					id
					timestamp
					temperature
				}
				checks {
					id
					temperature
					timestamp
				}
			}
			charter {
				debtor {
					name
				}
			}
		}
	}
`);

export const updateCargoActionLocation_mutation = gql(`#graphql
	mutation updateCargoActionLocation($actionId: Long!, $locationId: Long!) {
		updateLocation(actionId: $actionId, locationId: $locationId) {
			id
		}
	}
`);
